import { jsx, jsxs } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSIcon } from '../../icons/icon/index.esm.js';
import { useLocalization } from '@shared-ui/localization-context';
import styles from '../../styles/uitk-egds-action-list-item.css';
import { EGDSActionListItemSpacings } from '../types/index.esm.js';
import { EGDSContextProvider } from '../../utils/context-provider/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const ActionListItem = props => {
  const {
    active,
    borderSeparator,
    className,
    disabled,
    children,
    selected,
    spacing,
    l10n,
    ...attr
  } = props;
  const spacingType = spacing && EGDSActionListItemSpacings.get(spacing);
  const ariaDesc = selected ? l10n.formatText('selected') : '';
  const baseCssClass = 'uitk-action-list-item';
  const cssClassNames = getClassNameList(baseCssClass, className, {
    [`${baseCssClass}-selected`]: selected,
    [`${baseCssClass}-active`]: active,
    [`${baseCssClass}-disabled`]: disabled,
    [`${baseCssClass}-${spacingType}`]: spacingType,
    [`${baseCssClass}-border`]: borderSeparator
  });
  return jsx(EGDSContextProvider, {
    config: {
      context: null,
      data: {
        contextAriaDesc: ariaDesc
      }
    },
    children: jsxs("li", {
      className: cssClassNames,
      ...attr,
      children: [jsx("div", {
        className: getClassNameList('uitk-action-list-item-content'),
        children: children
      }), selected && jsx(EGDSIcon, {
        className: getClassNameList('uitk-action-list-item-check'),
        name: "check"
      })]
    })
  });
};
const EGDSActionListItem = props => {
  const l10n = useLocalization();
  return jsx(ActionListItem, {
    l10n: l10n,
    ...props
  });
};
EGDSActionListItem.defaultProps = {
  spacing: 'standard'
};
EGDSActionListItem.displayName = 'EGDSActionListItem';
export { ActionListItem, EGDSActionListItem };